import { useState } from "react";

import { useAuthContext } from "./useAuthContext";
import { API_URL } from "../config";
import { useSupervisorContext } from "./useSupervisorContext";

export const useAddSupervisor = () => {
  const { user } = useAuthContext();
  const { supervisors, dispatch } = useSupervisorContext();

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@must\.ac\.ug$/;
    if (!regex.test(email)) {
      setError("Please enter a valid supervisor email address");
      return false;
    } else {
      setError(null);
      return true;
    }
  };

  const validatePassword = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      // setError(`Passwords do not match ${password} ${confirmPassword}`);
      return false;
    }
    return true;
  };

  const addsupervisor = async (
    first_name,
    last_name,
    email,
    password,
    confirmPassword
  ) => {
    if (!validateEmail(email) || !validatePassword(password, confirmPassword)) {
      return; // Exit early if validation fails
    }
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/supervisors/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({
          first_name,
          last_name,
          email,
          password,
          role: "supervisor",
        }),
      });

      if (!response.ok) {
        const json = await response.json();
        throw new Error(json.error);
      }

      const json = await response.json();
      // console.log("Creating Supervisor:", json.supervisor);

      dispatch({ type: "ADD_SUPERVISOR", payload: json.supervisor });
      setSuccess("Success!! Login credentials sent to supervisor email");
    } catch (error) {
      setError(error.message || "An error occurred during adding supervisor");
    } finally {
      setIsLoading(false);
    }
  };

  return { addsupervisor, isLoading, error, success, setError, setSuccess };
};
